import { ResetPasswordForm } from '@/components/forms/ResetPasswordForm'

export default function ResetPasswordPage() {
  return <ResetPasswordForm />
}

